import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import Step1 from './Step1/index.jsx';
import Step2 from './Step2/index.jsx';
import Step3 from './Step3/index.jsx';
import Step4 from './Step4/index.jsx';
import Step5 from './Step5/index.jsx';

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

class WarrantyTransferForm extends React.Component {
  step(stepNum) {
    return {
      1: <Step1 />,
      2: <Step2 />,
      3: <Step3 />,
      4: <Step4 />,
      5: <Step5 />,
    }[stepNum];
  }

  render() {
    return <FormWrapper {...this.props}>{this.step(this.props.step)}</FormWrapper>;
  }
}

const mapStateToProps = state => ({
  step: state.step,
});

export default connect(mapStateToProps)(WarrantyTransferForm);
